export default __webpack_public_path__ + "static/media/windows.2bdab0dd.svg";